import React, { useState } from 'react';
import '../../../../views/stylesheet/styles.css';
import Divider from '@mui/material/Divider';
import Button from '@material-ui/core/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import ApiCall from '../../../../ApiService/ApiGateway/apiGateway';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
    position: toast.POSITION.BOTTOM_LEFT,
    autoClose: 3000
});

function Password({ close }) {
    const [password, setPassword] = useState({
        password: '',
        showPassword: false
    });
    const [newPassword, setNewPassword] = useState({
        newPassword: '',
        showPassword: false
    });
    const [confirmPassword, setConfirmPassword] = useState({
        confirmPassword: '',
        showPassword: false
    });

    const handleChange = (prop) => (event) => {
        setPassword({ ...password, [prop]: event.target.value });
    };
    const handleNewPasswordChange = (prop) => (event) => {
        setNewPassword({ ...newPassword, [prop]: event.target.value });
    };
    const handleConfirmPasswordChange = (prop) => (event) => {
        setConfirmPassword({ ...confirmPassword, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setPassword({
            ...password,
            showPassword: !password.showPassword
        });
    };
    const handleShowNewPassword = () => {
        setNewPassword({
            ...newPassword,
            showPassword: !newPassword.showPassword
        });
    };
    const handleShowConfirmPassword = () => {
        setConfirmPassword({
            ...confirmPassword,
            showPassword: !confirmPassword.showPassword
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const changePassword = () => {
        if (password.password === '') {
            toast.error('Please enter your password');
        } else if (newPassword.newPassword === '') {
            toast.error('Please enter new password');
        } else if (confirmPassword.confirmPassword === '') {
            toast.error('Please enter confirm password');
        } else if (newPassword.newPassword !== confirmPassword.confirmPassword) {
            toast.error('New Password and confirm password should be same');
        } else {
            let data = {
                new_pass: newPassword.newPassword,
                old_pass: password.password
            };
            ApiCall.patch(`admin/change_pass`, data, (response) => {
                console.log(response);
                close();
                toast.success(response.message);
            });
        }
    };

    return (
        <div className="drawerWidth">
            <div className="title2">Change Password</div>
            <Divider />
            <div className="content">
                <div className="mb-24">
                    <div className="fieldName">Current Password</div>
                    <div className="passwordField">
                        <OutlinedInput
                            className="password"
                            type={password.showPassword ? 'text' : 'password'}
                            value={password.password}
                            onChange={handleChange('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {password.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                </div>
                <div className="mb-24">
                    <div className="fieldName">New Password</div>
                    <div className="passwordField">
                        <OutlinedInput
                            className="password"
                            type={newPassword.showPassword ? 'text' : 'password'}
                            value={newPassword.newPassword}
                            onChange={handleNewPasswordChange('newPassword')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleShowNewPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {newPassword.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                </div>
                <div className="mb-30">
                    <div className="fieldName">Confirm Password</div>
                    <div className="passwordField">
                        <OutlinedInput
                            className="password"
                            type={confirmPassword.showPassword ? 'text' : 'password'}
                            value={confirmPassword.confirmPassword}
                            onChange={handleConfirmPasswordChange('confirmPassword')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleShowConfirmPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {confirmPassword.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                </div>
                <div className="buttons">
                    <div
                        className="cancel"
                        onClick={() => {
                            close();
                        }}
                    >
                        Cancel
                    </div>
                    <Button variant="contained" onClick={() => changePassword()}>
                        Save
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Password;
